import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/health").then((module) => ({
    default: module.AdminHealth,
  })),
);

export const Route = createFileRoute("/admin/health")({
  component: Page,
});
